<template>
	<div :class="classes">
		<header class="individual-tombstone-panel__head">
			<div class="individual-tombstone-panel__header">
				<div>
					<AssessmentHeader
						:user="user"
						:assessment="assessment"
					/>
					<FontAwesomeIcon
						class="individual-tombstone-panel__close-button"
						:icon="[ `fas`, `times` ]"
						@click.stop="$emit( `close` )"
					/>
				</div>
				<TeamingSegmentedButton
					class="individual-tombstone-panel__segment-button"
					:active-segment-name="activeSegment"
					left-segment-name="personal-details"
					right-segment-name="work-style"
					@change="onSegmentChange"
				>
					<template #left-segment>
						{{ translate( "personalDetailsButton", { name: user.shortDisplayName } ) }}
					</template>
					<template #right-segment>
						{{ translate( "workStyleButton" ) }}
					</template>
				</TeamingSegmentedButton>
			</div>
		</header>
		<main class="individual-tombstone-panel__body">
			<section :class="personalDetailsSegmentClasses" >
				<h2>{{ translate( "personalDetailsHeading", { name: user.displayName } ) }}</h2>
				<IndividualPersonalDetails
					:assessment="assessment"
					:user="user"
				/>
			</section>
			<section :class="workStyleSegmentClasses">
				<h2>{{ translate( "workStyleHeading" ) }}</h2>
				<div class="individual-tombstone-panel__workstyle">
					<IndividualDISCProfile
						:user="user"
					/>
				</div>
			</section>
		</main>
	</div>
</template>

<script>
import {
	TranslateMixin,
	EventsMixin,
	AssessmentHeader,
	TeamingSegmentedButton
} from "@teaming/common-ui";

import IndividualPersonalDetails from "./IndividualPersonalDetails";
import IndividualDISCProfile from "./IndividualDISCProfile";

export default {
	name: "IndividualTombstonePanel",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, EventsMixin, ],
	emits: [ "close", ],
	components: {
		AssessmentHeader,
		TeamingSegmentedButton,
		IndividualPersonalDetails,
		IndividualDISCProfile,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		user: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			activeSegment: "work-style",
		};
	},
	computed: {
		classes() {
			return `individual-panel ${ this.className }`.trim();
		},
		personalDetailsSegmentClasses() {
			return {
				"individual-tombstone-panel__segment": true,
				"individual-tombstone-panel__segment--active": this.activeSegment === "personal-details",
				"individual-tombstone-panel__personal-details-segment": true,
			};
		},
		workStyleSegmentClasses() {
			return {
				"individual-tombstone-panel__segment": true,
				"individual-tombstone-panel__segment--active": this.activeSegment === "work-style",
				"individual-tombstone-panel__work-style-segment": true,
			};
		},
		assessment() {
			return this.user?.assessments?.DISC || {};
		},
	},
	methods: {
		onSegmentChange( activeSegment ) {
			this.activeSegment = activeSegment;
		},
	},
};
</script>

<style lang="scss" scoped>
.individual-panel {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 1rem;

	padding: 1rem;
}

.individual-tombstone-panel__header {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1rem;

	width: 100%;

	div:first-child {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
}

.individual-tombstone-panel__body {
	@include auto-y-scroll();
	flex: 1;
}


.individual-tombstone-panel__segment {
	display: none;
	flex-direction: column;
	gap: 1rem;

	max-width: 35rem;
	min-height: 30rem;
	max-height: 30rem;

	> h2 {
		display: none;
		@include font-and-line-for(1);
		font-weight: 600;
		color: $individual-tombstone-panel-header-color;
		text-align: left;
	}
}

.individual-tombstone-panel__segment--active {
	display: flex;
}

.individual-tombstone-panel__personal-details-segment {
	> * {
		width: 100%;
	}
}

.individual-tombstone-panel__workstyle {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
}

.individual-tombstone-panel__close-button {
	cursor: pointer;
}
</style>
